import { shippingLabelTemplateSchema } from "@redotech/redo-fulfillment-operations-common/shipping-label/shipping-label-template-definition";
import * as z from "zod";

export const getOrCreateMerchantPrimaryShippingLabelTemplate = {
  name: "getOrCreateMerchantPrimaryShippingLabelTemplate" as const,
  input: z.object({}),
  output: shippingLabelTemplateSchema,
};
